/**
 * Language management utilities
 * English (id: 2) and Spanish (id: 3) are supported
 */

export const SUPPORTED_LANGUAGES = [
  { id: '2', name: 'English', code: 'en' },
  { id: '3', name: 'Español', code: 'es' },
] as const

export const DEFAULT_LANGUAGE_ID = '2' // English

const LANGUAGE_STORAGE_KEY = 'selected-language-id'

export function getSelectedLanguageId(): string {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
  if (stored && SUPPORTED_LANGUAGES.some(lang => lang.id === stored)) {
    return stored
  }
  return DEFAULT_LANGUAGE_ID
}

export function setSelectedLanguageId(languageId: string): void {
  if (SUPPORTED_LANGUAGES.some(lang => lang.id === languageId)) {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, languageId)
    // Update i18n translations
    import('./i18n.js').then(({ updateLanguage }) => {
      updateLanguage(languageId)
    })
    window.dispatchEvent(new CustomEvent('language-changed', { detail: { languageId } }))
  }
}

export function getLanguageName(languageId: string): string {
  const lang = SUPPORTED_LANGUAGES.find(l => l.id === languageId)
  return lang?.name || 'English'
}
